import React, { useEffect, useRef, useContext } from "react";
import { store } from "../context/store";
import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";
import am4themes_animated from "@amcharts/amcharts4/themes/animated";

import { DEFAULT_BLUE } from "../constants/general-constants";
import { functions } from "../constants/common-functions";
import { LICENCE_KEY } from "../constants/charts";
import {SYSTEM_BLUE_BACKGROUND_LIGHT} from "../constants/general-constants";

// am4core.useTheme(am4themes_animated);

am4core.addLicense(LICENCE_KEY);

export default function AmChartDoughnutIndicatorWhite({
  id,
  percentage,
  width,
  height,
  onClick,
  color,
}) {
  const chart = useRef(null);
  const globalState = useContext(store);

  useEffect(() => {
    // Build data
    const chartData = [
      { label: "live", value: percentage, color: color || "white" },
      { label: "grey", value: 100 - percentage, color: "#444" },
    ];

    // Create chart
    const x = am4core.create(id, am4charts.PieChart);
    x.data = chartData;
    x.fontSize = 12;
    x.radius = am4core.percent(100);
    x.innerRadius = am4core.percent(85);
    x.color = "#000";

    // Series
    const pieSeries = x.series.push(new am4charts.PieSeries());
    pieSeries.dataFields.value = "value";
    pieSeries.dataFields.category = "label";
    pieSeries.slices.template.strokeWidth = 0;
    pieSeries.labels.template.disabled = true;
    pieSeries.ticks.template.disabled = true;
    pieSeries.slices.template.fillOpacity = 0.8;
    pieSeries.slices.template.propertyFields.fill = "color";

    // Click handling (guard if not provided)
    pieSeries.slices.template.events.on("hit", (event) => {
      if (onClick) {
        const cat =
          event?.target?.dataItem?.dataContext?.label ??
          event?.target?.dataItem?.properties?.category;
        onClick(cat);
      }
    });

    // Center label
    const centerLabel = x.seriesContainer.createChild(am4core.Label);
    centerLabel.text = `${functions.formatNumber(percentage, 1)}%`;
    centerLabel.horizontalCenter = "middle";
    centerLabel.verticalCenter = "middle";
    centerLabel.textAlign = "middle";
    centerLabel.fontSize = 26;
    centerLabel.fill = am4core.color("#fff"); // white text
    centerLabel.isMeasured = false; // ensures it stays centered regardless of layout

    chart.current = x;

    return () => {
      x.dispose();
    };
  }, [id, percentage, color, onClick]);

  const containerStyle = {
    display: "flex",
    flexDirection: "column",
    overflow: "hidden",
    width: "100%",
    alignItems: "center",
    justifyContent: "space-around",
    minHeight: height,
  };

  const chartContainer = {
    display: "flex",
    width: `${width}px`,
    minHeight: `calc(${height}px - 40px)`,
  };

  return (
    <div style={containerStyle}>
      <div style={chartContainer} id={id} />
    </div>
  );
}
